import { takeLatest } from 'redux-saga/effects';
import { onList, onListSuccess, onListFailed } from './List';
import { OnCallRequestTypes } from '~/domain/interfaces/redux/onCallRequest/types';

const tasks = [
  takeLatest(OnCallRequestTypes.LIST, onList),
  takeLatest(OnCallRequestTypes.LIST_SUCCESS, onListSuccess),
  takeLatest(OnCallRequestTypes.LIST_FAILED, onListFailed),
];

export default tasks;
